import PhoneInput from 'react-phone-input-2';

export const PhoneAdapter = ({ input, ...rest }) => (
  <PhoneInput
    {...input}
    {...rest}
    country="us"
    enableAreaCodes={true}
    onlyCountries={['us']}
    value={input.value}
    onChange={value => input.onChange(value)}
    onBlur={() => input.onBlur()}
    className="form-control"
  />
);
